import { BarList } from '~/components/BarList'
import { CurrentWaitingListUnScheduledSurgery } from '~/hooks/useBaseCurrentWaitingListForStaffing'

import { useTransformToBarListItemBySurgeryCategory } from '../../../../shared'

type Props = {
    unScheduledSurgeriesByPractitioner: CurrentWaitingListUnScheduledSurgery[]
}

export const WaitingListByPractitionerBarList = ({ unScheduledSurgeriesByPractitioner }: Props) => {
    const waitingListItemsByPractitioner = useTransformToBarListItemBySurgeryCategory(unScheduledSurgeriesByPractitioner)

    return (
        <div className="max-h-[500px] overflow-auto">
            <BarList title="Operasjonskategori" unit="Klarert/Totalt" items={waitingListItemsByPractitioner} />
        </div>
    )
}
